import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionPanel,
} from "@fluentui/react-accordion";
import { t } from "i18next";
import {
  DefaultButton,
  IconButton,
  Icon,
  PrimaryButton,
  TooltipHost,
  TextField,
  Toggle,
} from "@fluentui/react";

import "./APIkeys.css";
import GenerateClientCredentialsModal from "./GenerateClientCredentialsModal";
import ModalHeader from "../Modal/ModalHeader";
import ConfirmationModalFooter from "../../pages/StudyList/components/Modal/PeerReviewTimeLineModal/ConfirmationModalFooter";
import ModalMain from "../Modal/ModalMain";
import {
  generateSecret,
  saveClientCredentials,
  updateClientStatus,
  updateSecretStatus,
} from "../../service/MasterService";
import themeContext from "../../context/theme/ThemeContext";
import loaderContext from "../../context/loader/LoaderContext";
import toastContext from "../../context/toast/ToastContext";
import { TOAST_TYPE } from "../../constants/Constants";

const SecretRow = ({ secret, isClientIdActive, isEditing, onToggleActive }) => {
  const canEditSecret = isEditing && isClientIdActive;
  const isSecretActive = isClientIdActive && secret.active;
  return (
    <div className="secret-row">
      <div className="secret-left">
        <div className="secret-left-value">
            <div className="secret-value">••••••••••{secret.maskedSecret}</div>
        </div>
        <div className="secret-left-info">
          <div className="secret-expiry">Created On: {secret.createdOn}</div>
          <div className="secret-expiry">Expires On: {secret.expiresOn ? secret.expiresOn : "-"}</div>
        </div>
      </div>

      <div className="secret-right"
      // style={{width:isEditing?"8%":"5%"}}
      >
        {canEditSecret ? (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Toggle
              checked={!!secret.active}
              onText="Active"
              offText="Inactive"
              styles={{ root: { marginBottom: 0 } }}
              onChange={(e, checked) => onToggleActive(secret.id, checked)}
              ariaLabel={`Toggle secret ${secret.maskedSecret} active state`}
            />
          </div>
        ) : (
          <span className="secret-status">
            {isSecretActive ? (
              <>
                <span className="active-green-dot" style={{ display: "block" }}></span>
                <span>Active</span>
              </>
            ) : (
              <>
                <span className="inactive-red-dot"></span>
                <span>Inactive</span>
              </>
            )}
          </span>
        )}

        {/* <IconButton iconProps={{ iconName: "Delete" }} title="Delete Secret" /> */}
      </div>
    </div>
  );
};

const ClientHeader = ({ client, isEditing, onToggleActive }) => (
  <div className="client-header">
    <div className="client-header-left">
      <div className="client-name">
        <div style={{display:"flex",alignItems:"center",gap:"5px"}}>
        <Icon iconName="Permissions" />
        <span>{client.displayName}</span>
        </div>
        <div style={{marginRight:"20px"}}>        
          {isEditing ? (
          <div
            onClick={(e) => e.stopPropagation()}
            style={{ display: "inline-flex", alignItems: "center", marginLeft: "12px" }}
          >
            <Toggle
              checked={!!client.active}
              onText="Active"
              offText="Inactive"
              styles={{ root: { marginBottom: 0 } }}
              onChange={(e, checked) => onToggleActive(client.id, checked)}
              ariaLabel={`Toggle client ${client.displayName} active state`}
            />
          </div>
        ) : (
          <span
            className="client-status"
            style={{ display: "inline-flex", alignItems: "center", marginLeft: "12px" }}
          >
            <span
              className={client.active ? "active-green-dot" : "inactive-red-dot"}
              style={{ display: "block" }}
            ></span>
            <span>{client.active ? "Active" : "Inactive"}</span>
          </span>
        )}
        </div>
      </div>
    </div>
  </div>
);

const ApiKeysSection = (props) => {
  const { getThemeColor } = useContext(themeContext);
  const { setLoaderRunning, ref } = useContext(loaderContext);
  const { showToastv2 } = useContext(toastContext);
  const [showGenerateModal, setShowGenerateModal] = useState(false);
  const [showGenerateSecretModal, setShowGenerateSecretModal] = useState(false);
  const [clientName, setClientName] = useState("");
  const [selectedClientName, setSelectedClientName] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");
  const [generateSecretConfimation, setGenerateSecretConfirmation] =
    useState(false);


  const [pendingToggle, setPendingToggle] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);

  const [description, setDescription] = useState("");

  const [selectedFirmIds, setSelectedFirmIds] = useState([]);

  const [selectedScopes, setSelectedScopes] = useState([]);

  const [generatedSecret, setGeneratedSecret] = useState("");

 const [apiKeys, setApiKeys] = useState(
    Array.isArray(props?.apiKeys) ? props.apiKeys : []
);

  const [visible, setVisible] = useState(false);

  const [copied, setCopied] = useState(false);
  const [clientIdCopied,setClientIdCopied]=useState(false);

  const modalRef = useRef();

  useEffect(() => {
      setApiKeys(Array.isArray(props?.apiKeys) ? props.apiKeys : []);
  }, [props?.apiKeys]);

  const updateApiKeys = (updater) => {
    setApiKeys((previousApiKeys) => {
      const nextApiKeys =
        typeof updater === "function" ? updater(previousApiKeys) : updater;
      props?.onApiKeysChange?.(nextApiKeys);
      return nextApiKeys;
    });
  };

  const handleToggleClientActive = async (clientId, checked) => {
    const previousApiKeys = apiKeys;

    // Optimistic update so the switch feels immediate.
    updateApiKeys((prev) =>
      prev.map((client) =>
        client.fetchedClientCreds.id === clientId
          ? {
              ...client,
              fetchedClientCreds: {
                ...client.fetchedClientCreds,
                active: checked,
              },
            }
          : client,
      ),
    );

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await updateClientStatus({
        clientId,
        active: checked,
      });

      if (!(response?.status === 200 && response.data?.result === "SUCCESS")) {
        updateApiKeys(previousApiKeys);
        console.log("API response",response.data)
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
      }else{
        showToastv2(TOAST_TYPE.INFO, response?.data?.data);
      }
      
    } catch (err) {
      console.error(err);
      updateApiKeys(previousApiKeys);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("client-credentials.updateClientStatusFailure"),
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const handleToggleSecretActive = async (clientId, secretId, checked) => {
    const previousApiKeys = apiKeys;

    updateApiKeys((prev) =>
      prev.map((client) => {
        if (client.fetchedClientCreds.id !== clientId) return client;
        return {
          ...client,
          secrets: (client.secrets || []).map((s) =>
            s.id === secretId ? { ...s, active: checked } : s,
          ),
        };
      }),
    );

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await updateSecretStatus({
        clientId,
        secretId,
        active: checked,
      });

      if (!(response?.status === 200 && response.data?.result === "SUCCESS")) {
        updateApiKeys(previousApiKeys);
        showToastv2(TOAST_TYPE.ERROR, response?.data?.data);
      }else{
              showToastv2(TOAST_TYPE.INFO, response?.data?.data);
      }
    } catch (err) {
      console.error(err);
      updateApiKeys(previousApiKeys);
      showToastv2(
        TOAST_TYPE.ERROR,
        t("client-credentials.updateSecretStatusFailure"),
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };


  const requestToggleClientActive = (clientId, checked, displayName) => {
    setPendingToggle({
      type: "client",
      clientId,
      checked,
      label: displayName,
    });
    setShowConfirmModal(true);
  };

  const requestToggleSecretActive = (clientId, secretId, checked, maskedSecret) => {
    setPendingToggle({
      type: "secret",
      clientId,
      secretId,
      checked,
      label: maskedSecret,
    });
    setShowConfirmModal(true);
  };

  const handleCancelToggle = () => {
    setShowConfirmModal(false);
    setClientName("");
    setDescription(" ");
    setPendingToggle(null);
  };

  const handleConfirmToggle = () => {
    if (!pendingToggle) return;
    const { type, clientId, secretId, checked } = pendingToggle;

    setShowConfirmModal(false);

    if (type === "client") {
      handleToggleClientActive(clientId, checked);
    } else if (type === "secret") {
      handleToggleSecretActive(clientId, secretId, checked);
    }

    setPendingToggle(null);
  };

  const handleGenerate = async () => {
    const payload = {
      displayName: clientName,

      description: description,

      firmIds: selectedFirmIds,

      externalFirmId: props?.externalFirmId,

      scopeIds: selectedScopes,
    };
    if (!modalRef.current.validate()) {
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await saveClientCredentials(payload);
      const data = response?.data?.data || {};

      if (response?.status === 200 && response.data?.result === "SUCCESS") {
        setGeneratedSecret(data?.secrets[0].secret);
        updateApiKeys((prev) => [...prev, data]);
        setShowGenerateModal(false);
        setClientName("");
        setDescription("");
        setVisible(true);
      } else {
        setShowGenerateModal(false);
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
      }
    } catch (err) {
      console.error(err);

      showToastv2(
        TOAST_TYPE.ERROR,
        t("client-credentials.generateClientFailure"),
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const hideModal = () => {
    setShowGenerateModal(false);
  };

  const takeGenerateSecretConfirmation = (clientId, displayName) => {
    setSelectedClientId(clientId);
    setSelectedClientName(displayName);
    setShowGenerateSecretModal(true);
  };
  const handleGenerateSecret = async () => {
    const payload = {
      clientCredentialId: selectedClientId,
      clientCredentialDisplayName: selectedClientName,
    };

    setLoaderRunning(true);
    ref.current.continuousStart();
    try {
      const response = await generateSecret(payload);
      const data = response?.data?.data || {};

      if (response?.status === 200 && response.data?.result === "SUCCESS") {
        setGeneratedSecret(data?.secret);
        setVisible(true);
        updateApiKeys((prev) =>
          prev.map((client) => {
            if (client.fetchedClientCreds.id === selectedClientId) {
              return {
                ...client,
                secrets: [...(client.secrets || []), data], 
              };
            }
            return client;
          }),
        );
      } else {
        setShowGenerateSecretModal(false);
        showToastv2(TOAST_TYPE.ERROR, response?.data?.message);
      }
    } catch (err) {
      console.error(err);

      showToastv2(
        TOAST_TYPE.ERROR,
        t("client-credentials.generateSecretFailure"),
      );
    } finally {
      setLoaderRunning(false);
      ref.current.complete();
    }
  };

  const confirmationModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={t("client-credentials.confirmStatusChangeTitle")}
        handleCancel={handleCancelToggle}
      />
    ),
    body: (
      <div style={{ padding: "3%", fontWeight: "600" }}>
        {pendingToggle?.type === "client" ? (
          <div>
            {t("client-credentials.messages.confirmClientStatusChange", {
              clientName: pendingToggle?.label,
              status: pendingToggle?.checked
                ? t("client-credentials.active")
                : t("client-credentials.inactive"),
            })}
          </div>
        ) : (
          <div>
            {t("client-credentials.messages.confirmSecretStatusChange", {
              status: pendingToggle?.checked
                ? t("client-credentials.active")
                : t("client-credentials.inactive"),
            })}
          </div>
        )}
      </div>
    ),
    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <DefaultButton text="No" onClick={handleCancelToggle} />
          <PrimaryButton
            style={{ margin: "0px 5px" }}
            text="Yes"
            onClick={handleConfirmToggle}
          />
        </div>
      </div>
    ),
    width: "500px",
  };

  const generateClientCredentialsModalDetails = {
    header: (
      <ModalHeader
        updatedModal
        heading={t("client-credentials.generateClient")}
        handleCancel={() =>{ 
          setClientName("");
          setDescription("")
          setShowGenerateModal(false)}}
      />
    ),

    body: (
      <GenerateClientCredentialsModal
        firms={props.firms}
        clientName={clientName}
        setClientName={setClientName}
        description={description}
        setDescription={setDescription}
        selectedFirmIds={selectedFirmIds}
        setSelectedFirmIds={setSelectedFirmIds}
        selectedScopes={selectedScopes}
        setSelectedScopes={setSelectedScopes}
        scopes={props?.scopes}
        ref={modalRef}
        onCancel={() => setShowGenerateModal(false)}
      />
    ),

    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <PrimaryButton
            text={t("client-credentials.generate")}
            onClick={handleGenerate}
            style={{ marginRight: "5px" }}
          />
          <DefaultButton
            text={t("client-credentials.close")}
            style={{ marginRight: "5px" }}
            onClick={() => {
              setClientName("");
              setDescription("");
              setSelectedFirmIds([]);
              setSelectedScopes([]);
              setShowGenerateModal(false);
            }}
          />
        </div>
      </div>
    ),

    width: "500px",
  };
  const generateSecretModalDetails = {
    header: (
      <ModalHeader
        updatedModal
        heading="Generate Secret"
        handleCancel={() => setShowGenerateSecretModal(false)}
      />
    ),

    body: (
      <div style={{ padding: "2%", fontWeight: "500" }}>
        {t("client-credentials.messages.generateSecretConfirmation", {clientName: selectedClientName,})}
      </div>
    ),

    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <PrimaryButton
            text={t("client-credentials.generate")}
            onClick={() => {
              setShowGenerateSecretModal(false);
              handleGenerateSecret()}}
            style={{ marginRight: "5px" }}
          />
          <DefaultButton
            text={t("client-credentials.close")}
            style={{ marginRight: "5px" }}
            onClick={() => {
              setShowGenerateSecretModal(false);
            }}
          />
        </div>
      </div>
    ),

    width: "500px",
  };
  const copyModalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={"Alert"}
        handleCancel={() => {
          setGeneratedSecret("");
          setVisible(false);
          setShowGenerateModal(false);
        }}
      />
    ),
    body: (
      <div style={{ padding: "2%", fontWeight: "500" }}>
        <div style={{ marginBottom: "10px" }}>
          {t("client-credentials.messages.secretVisibleOnce")}
        </div>
        <div style={{ display: "flex", alignItems: "center" }}>
          <TextField
            readOnly
            type="password"
            value={generatedSecret}
            canRevealPassword
            styles={{ root: { flexGrow: 1, marginRight: "8px" } }}
          />
          <IconButton
            iconProps={{ iconName: "Copy" }}
            title="Copy"
            ariaLabel="Copy"
            onClick={() => {
              navigator.clipboard.writeText(generatedSecret);
              setCopied(true);
              setTimeout(() => setCopied(false), 2000);
            }}
          />
        </div>
        <p>
          {" "}
          {copied && (
            <span style={{ color: "green", marginLeft: "10px" }}>
          {t("client-credentials.messages.copySecret")}
            </span>
          )}
        </p>
      </div>
    ),
    footer: (
      <div
        className="modal-footer-container"
        style={{
          background: getThemeColor("modal-header-footer"),
        }}
      >
        <div className="confirm-modal-footer">
          <DefaultButton
            text="Close"
            style={{ marginRight: "5px" }}
            onClick={() => {
              setGeneratedSecret("");
              setVisible(false);
            }}
          />
        </div>
      </div>
    ),
    width: "500px",
  };
  return (
    <div className="config-section">
      <div className="api-section-header">
        <h3>Client Credentials</h3>
        {props.isEditing && apiKeys.length==0 && (
          <PrimaryButton
            text="+ Generate Client Id"
            onClick={() => setShowGenerateModal(true)}
          />
        )}
      </div>
      {apiKeys.length==0 ? <div style={{textAlign:"center"}}>No client credentials Available </div> : <Accordion collapsible>
        {apiKeys.map((client) => {
          const firmAccessText = client.firmAccess?.join(", ");
          return (
            <div
              className="api-client-card"
              key={client.fetchedClientCreds.id}
            >
              <AccordionItem
                value={client.fetchedClientCreds.clientId}
              >
                <AccordionHeader expandIconPosition="end">
                  <ClientHeader
                    client={client.fetchedClientCreds}
                    isEditing={props.isEditing}
                    onToggleActive={(clientId, checked) =>
                      requestToggleClientActive(
                        clientId,
                        checked,
                        client.fetchedClientCreds.displayName,
                      )
                    }
                  />
                </AccordionHeader>

                <AccordionPanel>
                  <div className="client-details">
                    <div className="details">
                      <div className="item" style={{ width: "33%" }}>
                        <div>
                          <label>Client ID</label>
                          {/* <IconButton
                            iconProps={{ iconName: "Copy" }}
                            title="Copy"
                          /> */}
                        </div>

                        <div className="detail-value">
                          {client.fetchedClientCreds.clientId}
                           <IconButton
                            iconProps={{ iconName: "Copy" }}
                            title="Copy"
                            ariaLabel="Copy"
                            onClick={() => {
                              navigator.clipboard.writeText(client.fetchedClientCreds.clientId);
                              setClientIdCopied(true);
                              setTimeout(() => setClientIdCopied(false), 2000);
                            }}
                          />
                        </div>
                      </div>

                      <div className="item" style={{ width: "25%" }}>
                        <label>Created On</label>
                        <div className="detail-value">
                          {client.fetchedClientCreds.createdAt}
                        </div>
                      </div>

                      <div className="item" style={{ width: "33%" }}>
                        <label>Description</label>
                        <div className="detail-value">
                          {client.fetchedClientCreds.description}
                        </div>
                      </div>

                      {/* <div className="item" style={{ width: "35%" }}>
                        <label>Scopes</label>
                        <div className="scope-container">
                          {Array.isArray(client.scopes) &&
                            client.scopes.map((scope) => (
                              <span className="scope-chip" key={scope}>
                                {scope}
                              </span>
                            ))}
                        </div>
                      </div> */}

                      {/* <div className="item" style={{ width: "29%" }}>
                        <label>Firm Access</label>
                        <TooltipHost content={firmAccessText}>
                          <div className="firm-access-text">
                            {firmAccessText}
                          </div>
                        </TooltipHost>
                      </div> */}
                    </div>

                    <div className="secret-header">
                      {props.isEditing && client.fetchedClientCreds.active && (
                        <PrimaryButton
                          text="+ Add Secret"
                          onClick={() =>
                            takeGenerateSecretConfirmation(
                              client.fetchedClientCreds.id,
                              client.fetchedClientCreds.displayName,
                            )
                          }
                        />
                      )}
                    </div>

                    <div>
                      {client.secrets && client.secrets === 0 ? (
                        <div className="empty-secret">No Secrets Generated</div>
                      ) : (
                        client.secrets.map((secret) => (
                          <SecretRow
                            key={secret.id}
                            isClientIdActive={client.fetchedClientCreds.active}
                            secret={secret}
                            isEditing={props.isEditing}
                            onToggleActive={(secretId, checked) =>
                              requestToggleSecretActive(
                                client.fetchedClientCreds.id,
                                secretId,
                                checked,
                                secret.maskedSecret,
                              )
                            }
                          />
                        ))
                      )}
                    </div>

                    {/* <div className="client-actions">
                      <DefaultButton text="Deactivate Client" />

                      <DefaultButton
                        text="Delete Client"
                        iconProps={{ iconName: "Delete" }}
                      />
                    </div> */}
                  </div>
                </AccordionPanel>
              </AccordionItem>
            </div>
          );
        })}
      </Accordion>}
      {showGenerateModal && (
        <ModalMain
          modalDetails={generateClientCredentialsModalDetails}
          showModal={showGenerateModal}
        />
      )}
      {visible && (
        <ModalMain modalDetails={copyModalDetails} showModal={visible} />
      )}
      {showGenerateSecretModal && (
        <ModalMain
          modalDetails={generateSecretModalDetails}
          showModal={showGenerateSecretModal}
        />
      )}
      {showConfirmModal && (
        <ModalMain
          modalDetails={confirmationModalDetails}
          showModal={showConfirmModal}
        />
      )}
    </div>
  );
};

export default ApiKeysSection;
